import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";

import NavigationBar from './components/navigation/Navigation'; 
import Home from './components/home/Home'; 
import MouseFX from './mouse/MouseFX'; 
import Service from './components/services/Services';   
import Gallery from './components/gallery/Gallery'; 
import Testimonials from './components/testimonials/Testemonials';  
import Contact from './components/contact/Contact'; 
import Stats from './components/statistic/Stats';
import RatingsWidget from './components/ratings/RatingsWidget'; 
import ProcessTimeline from './components/process/ProcessTimeline';
import FooterPro from './components/footer/Footer';
import LegalModal from './components/legal/LegalModal'; 
import Trust from './components/trustBadge/TrustBadge';
import BeforeAfterShowcase from './components/beforeAfter/BeforeAfter';


function App() {
  // state for which legal page to show in modal
  const [legalSlug, setLegalSlug] = useState(null);

  return (
    <Router>
      <div className="App">
        <NavigationBar />
        <MouseFX />
        <Routes>
          {/* Homepage (all your sections) */}
          <Route
            path="/"
            element={
              <>
                <Home />
                <Stats />
                <Service />
                <Gallery />
                <ProcessTimeline />
                <BeforeAfterShowcase />
                <Testimonials />      
                <RatingsWidget /> 
                <Trust />
                <Contact />
              </>
            }
          />
        </Routes>

        {/* Footer with legal modal support */}
        <FooterPro onOpenLegal={(slug) => setLegalSlug(slug)} />

        {/* Modal itself */}
        <LegalModal slug={legalSlug} onClose={() => setLegalSlug(null)} />
      </div>
    </Router>
  );
}

export default App;
